var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiOptionBase',{attrs:{"fullItemList":_vm.titleDesignators,"preSelectedItemList":_vm.preSelectedList,"displayedKey":"name","heading":"Title Designators"},on:{"changes":changes => _vm.$emit( 'changes', changes ),"removal":function($event){return _vm.$emit( 'removal', 'designators' )}}})
}
var staticRenderFns = []

export { render, staticRenderFns }